import { useReducer, useEffect } from 'react';
import Client from 'containers/app/client';

const initialState = {
  organization: null,
  loading: true,
  error: null,
};

export const FETCH_ORG = 'FETCH_ORG';
export const SET_ORG = 'SET_ORG';
export const REMOVE_ORG = 'REMOVE_ORG';
export const SET_ERROR = 'SET_ERROR';

export const reducer = (state, action) => {
  switch (action.type) {
    case FETCH_ORG:
      return { ...state, organization: null, loading: true };
    case SET_ORG:
      return {
        ...state,
        organization: action.payload.organization,
        loading: false,
      };
    case REMOVE_ORG:
      return {
        ...state,
        organization: null,
        loading: false,
        error: 'user not signed in',
      };
    case SET_ERROR:
      return {
        organization: null,
        loading: false,
        error: action.payload.error,
      };
    default:
      throw new Error('Action not supported');
  }
};

export const useUserOrganization = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    return Client.auth.onAuthStateChanged(async (user) => {
      if (!user) dispatch({ type: REMOVE_ORG });
      dispatch({ type: FETCH_ORG });
      try {
        const refProfile = Client.dbDoc(`users/${user.uid}`);
        const docProfile = await refProfile.get();
        const { organization } = docProfile.data();

        if (!organization)
          return dispatch({
            type: SET_ORG,
            payload: {
              organization: null,
            },
          });

        const orgRef = Client.dbDoc(`organizations/${organization}`);
        const orgDoc = await orgRef.get();

        return dispatch({
          type: SET_ORG,
          payload: {
            organization: {
              id: orgDoc.id,
              ...orgDoc.data(),
            },
          },
        });
      } catch (e) {
        return dispatch({ type: SET_ERROR, error: e });
      }
    });
  }, []);

  return [state.organization, state.loading, state.error];
};
